import { render, staticRenderFns } from "./ModifyStatusPopup.vue?vue&type=template&id=8b4d5d96&"
import script from "./ModifyStatusPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyStatusPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports